import { render } from "./FooterObject.vue?vue&type=template&id=6d49bb0f"
import script from "./FooterObject.vue?vue&type=script&lang=js"
export * from "./FooterObject.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__